import { Axios } from "../hooks/useAxiosInstance";

export const SoundTracksManagement = (function () {

    // const { api_token } = useSelector(state => state.profile);

    const apis = () => ({
        fetch: async ({ api_token }) => await fetchRecord(api_token),
        delete: async ({ audio_slug, api_token }) => await deleteRecord(audio_slug, api_token),
    })

    async function fetchRecord(api_token) {
        const url = "api/admin/sound-tracks";
        const option = {
            headers: {
                'Authorization': api_token,
                'Content-Type': 'application/json'
            }
        }

        return await Axios.get(url, option);
    }

    async function deleteRecord(audio_slug, api_token) {
        const url = `api/admin/sound-tracks/${audio_slug}`;
        const option = {
            headers: {
                'Authorization': api_token,
                'Content-Type': 'application/json'
            }
        }

        return await Axios.delete(url, option);
    }

    return apis();

})()
